<template>
    <h2 class="home-title flex-row items-center">
        <span class="home-title-text">{{ txt }}</span>
        <template v-if="toMore">
            <MoreVue :to="toMore" />
        </template>
    </h2>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import MoreVue from "../../../components/More.vue";
export default defineComponent({
    name: "HomeTitle",
    components: { MoreVue },
    props: {
        txt: {
            type: String,
            default: ''
        },
        toMore: {
            type: String,
            default: ''
        }
    },
    setup() {
        // 此处应该有防抖函数
        return {
        }
    }
})
</script>
<style lang="scss" scoped>
.home-title {
    height: 33px;
    .home-title-text {
        height: 33px;
        font-size: 24px;
        font-weight: 600;
        color: #1c7fbb;
        line-height: 33px;
    }
}
</style>
